<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" ref="input" :disabled="disabled ? true : null" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import FiscalPeriodList from '~/views/fiscal-periods/fiscal-period-list.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: {}
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					onlyCurrentCompany: true,
					loadOnMount: true,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						selectorWidth: 'auto',
						display: (item) => item ? `${item.name}` : '',
						buttons: [{
							title: this.$t('list'),
							shortcut: $sc.find('enter'),
							element: () => { return this.$el },
							isPrimary: true,
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showFiscalPeriods()
							}
						}]
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				all: 'fiscalPeriods/all',
				getByCompanyId: 'fiscalPeriods/getByCompanyId',
				company: 'appContext/getCompany'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				if (this.settings.onlyCurrentCompany && this.company) {
					return this.getByCompanyId(this.company.id)
				}
				return this.all
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			if (this.settings.loadOnMount) {
				this.refreshFiscalPeriods()
			}
		},
		methods: {
			...mapActions({
				refreshFiscalPeriods: 'fiscalPeriods/refresh'
			}),
			showFiscalPeriods() {
				this.showModal({ component: FiscalPeriodList, data: null, options: { selectable: true, modelValue: this.dropdownValue } })
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
